/** Delivery feature flags (Model C1). Service fee: fetch via deliveryConfigService. */

export const DELIVERY_ENABLED = true;

export const DELIVERY_FEES_LABEL = 'Delivery & fees';
